import React from 'react';

import Button from 'components/Button';

import { useTable, useSortBy, usePagination } from 'react-table';

import './style.css';

function Table({ columns = [], data = [], callback = () => {}, pageSizeProp = 20 }) {
	const {
		getTableProps,
		getTableBodyProps,
		headerGroups,
		page,
		prepareRow,
		pageCount,
		canPreviousPage,
		canNextPage,
		nextPage,
		pageOptions,
		previousPage,
		state: { pageIndex },
	} = useTable(
		{
			columns,
			data,
			autoResetPage: false,
			autoResetFilters: false,
			initialState: { pageIndex: 0, pageSize: pageSizeProp },
		},
		useSortBy,
		usePagination
	);

	const _handleNextPage = e => {
		try {
			e?.preventDefault();
			nextPage();
		} catch (error) {}
	};

	const _handlePreviousPage = e => {
		try {
			e?.preventDefault();
			previousPage();
		} catch (error) {}
	};

	return (
		<>
			<table {...getTableProps()} className="Table">
				<tbody {...getTableBodyProps()}>
					{headerGroups.map(headerGroup => (
						<tr {...headerGroup.getHeaderGroupProps()}>
							{headerGroup.headers.map((column, idx) => (
								<th {...column.getHeaderProps(column.getSortByToggleProps())} key={idx}>
									{column.render('Header')}
									{column.isSorted && <span className="sorted_indicator">{column.isSortedDesc ? '⬇' : '⬆'}</span>}
								</th>
							))}
						</tr>
					))}
					{page?.map((row, idx) => {
						prepareRow(row);
						return (
							<tr key={idx}>
								{row.cells.map(cell => (
									<td {...cell.getCellProps()} onClick={() => callback(cell)}>
										{cell.render('Cell')}
									</td>
								))}
							</tr>
						);
					})}
				</tbody>
			</table>
			{pageCount > 1 && (
				<div className="pagination">
					<span className="page_number">
						Page {pageIndex + 1} of {pageOptions?.length}
					</span>
					<Button small onClick={_handlePreviousPage} title="<" disabled={!canPreviousPage} type="outline" />
					<Button small onClick={_handleNextPage} title=">" disabled={!canNextPage} type="outline" />
				</div>
			)}
		</>
	);
}
export default Table;
